export default __webpack_public_path__ + "9562a6cc2031eec9c8201b09d25b6ce8.svg";